import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';
import { homeForRole } from './roleHome';
import { isSignedIn } from './signedIn';

const ALLOWED: ReadonlyArray<string> = ['admin', 'dispatcher', 'finance'];

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // An anonymous guest session (/order) is not an account — sign in first.
  if (!isSignedIn(user)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!user.role || !ALLOWED.includes(user.role)) {
    // Wrong-role users get bounced to their own shell rather than /no-access.
    return <Navigate to={homeForRole(user.role)} replace />;
  }

  return <>{children}</>;
}
